/**
 * 路由前置守卫
 * 功能：query 带 token 时写入 cookie 实现免密登录，按 resource_path 拉取按钮权限存入 localStorage，无 token 跳 403
 */
import router from './router'
import serverPath from "@/config/config.js";
import {
  getToken,
  setToken
} from "../src/utils/cookies"
import {
  getButton
} from "@/api/auth"
/**
 * 路由跳转拦截器
 */
router.beforeEach((to, from, next) => {
  if (to.path == "/" && typeof to.query.token !== "undefined") {
    let getinfo = to.query.token
    setToken(getinfo);
  }
  var token = getToken();
  var path = to.path;
  if (path == "/403") {
    next()
    return false
  }
  if (token) {
    let path = to.path == "/" || to.path == "/homePage" ? "/homePage" : to.path;
    if (path != "/") {
      let para = {
        resource_path: path,
      };
      //获取按钮权限
      getButton(para).then((result) => {
        let resource = result.data;
        if (resource != null) {
          localStorage.setItem(to.name + "_button", JSON.stringify(resource));
          next();
        }
      });
    } else {
      next();
    }
  } else {
    next("/403");
    let url = ""
    // switch (serverPath.env) {
    //   case "dev":
    //     url = "http://192.168.93.13:8088/";
    //   case "test":
    //     url = "http://192.168.93.14:8088/";
    //   case "prod":
    //     url = "http://auth.delaman168.com/";
    //   default:
    //     next("/403");
    // }
    // window.open(url, "_blank");
    return false
  }
})

